import FireBase from "@/client/services/fireBase/apis";
import i18nFunctions from "client/utils/i18n";
import { fireBaseAnalytics } from "client/services/fireBase/firebaseConfig";

const onPageInit = async (props) => {
  const { i18n } = i18nFunctions;
  const { currentUser } = props;

  const userDetails = await FireBase.getUserDetails({ currentUser });

  const userProgress = await FireBase.getUserProgress({ currentUser });

  const onPageInitProps = {
    loadingText: i18n("loading.text"),
    viewCourseButton: {
      label: i18n("button.view.course", {
        person: { en: "Raheel", ur: "راحیل" },
      }),
    },
    userDetails,
    userProgress,
  };

  return onPageInitProps;
};

const onSubmit = (props) => () => {
  fireBaseAnalytics.logEvent("dashboard_button_clicked");
};

const functions = { onPageInit, onSubmit };

export default functions;
